import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { QuestionSection } from '../../../../common/enums/QuestionSection';
import { IBindingAction } from '../../../../common/models/callback';
import Icon from '../../../../components/Icon';
import RegularButton from '../../../../components/RegularButton';
import { getIntl } from './utils';

interface ISectionBreakProps {
  type: QuestionSection;
  firstName?: string;
  onNextPage: IBindingAction;
}

const SectionBreak: FunctionComponent<ISectionBreakProps> = ({ type, firstName, onNextPage }) => {
  const intl = getIntl(type);

  const getDescElement = () => {
    switch (type) {
      case QuestionSection.Questions:
        return <FormattedMessage {...intl.description[0]} />;
      case QuestionSection.SoftSkills:
        return (
          <>
            <FormattedMessage {...intl.description[0]} values={{ breakingLine: <br />, firstName }} />
            <span className="font-weight-bold">
              <FormattedMessage {...intl.description[1]} />
            </span>
          </>
        );
      default:
        return '';
    }
  };

  return (
    <div className="survey-question-block">
      <p className="survey-page-title">
        <FormattedMessage {...intl.title} />
      </p>
      <div className="survey-page-description">
        <span>
          {getDescElement()}
        </span>
      </div>
      <div className="survey-buttons">
        <RegularButton
          size="lg"
          textIntlId="Continue"
          defaultMessage="Continue"
          iconPosition="right"
          icon={<Icon icon="arrowRight" />}
          onClick={onNextPage}
        />
      </div>
    </div>
  );
};

export default SectionBreak;
